
import { useRoute } from 'vue-router';
import { computed } from 'vue';

export default {
  setup() {
    const route = useRoute();

    // Lista pagine con rispettive guide
    const guide = {
      '/Registro/SchedaPaziente': 'SchedaPazienteWeb.pdf',
      '/Registro/Taccuino': 'TaccuinoWeb.pdf',
      '/Registro/Farmaci': 'FarmaciWeb.pdf',
      '/Registro/Anamnesi': 'AnamnesiWeb.pdf',
      '/Registro/Esami': 'EsamiWeb.pdf',
      '/Registro/Diagnosi': 'DiagnosiWeb.pdf',
      '/Registro/Vaccini': 'VacciniWeb.pdf',
      '/Registro/File': 'FilesWeb.pdf',
      '/Registro/Dottori': 'DottoriWeb.pdf',
      '/Registro/Visite': 'VisiteWeb.pdf',
      '/centriConvezionati/CentriConvezionati': 'CentriDiagnosticiWeb.pdf',
      '/Altro': 'AltroWeb.pdf',
      '/Report': 'ReportWeb.pdf'
    };

    // Rintraccia se si trova nella pagina della calcolatrice
    const isCalcolatrice = computed(() => route.path.toLowerCase().startsWith('/calcolatricemedica/'));
    const currentGuide = computed(() => {
      if (isCalcolatrice.value) {
        return {
          path: '/userGuide/CalcolatriceWeb.pdf',
          name: 'CalcolatriceWeb.pdf'
        };
      }

      // Recupera il tipo di guida
      const fileName = guide[route.path];
      return fileName
        ? { path: `/userGuide/${fileName}`, name: fileName }
        : null;
    });

    // Scarica la guida
    const downloadGuide = (relativePath: string, guideFileName: string) => {
      const link = document.createElement('a');
      link.href = relativePath;
      link.download = guideFileName;
      link.click();
    };

    return {
      downloadGuide,
      currentGuide,
      route
    };
  }
};
